import { useTranslation } from "react-i18next";
import { type NavigationNodeDTO } from "~/domains/navigation/types/NavigationTypes";

import classes from "./PageFooter.module.less";
import { Fragment } from "react";
import { Link } from "../Link";

interface Props extends Data {
  className?: string;
}

export const PageFooter = ({ navigation, salesRep }: Props) => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className="container">
        <div className="jsp__footer__navigation">
          <div className="jsp__footer__links-section">
            {navigation.map((column, columnIndex) => (
              <ul key={columnIndex} className="jsp__footer__links-column">
                {column.children.map((link) => (
                  <Fragment key={link.title}>
                    {link.url && (
                      <Link
                        className="js__gs-footer-link jsp__footer__link"
                        data-ga-name={link.gaLabel}
                        id={link.gaLabel}
                        href={link.url}
                      >
                        {t(link.title)}
                      </Link>
                    )}
                    {!link.url && <p className="jsp__footer__link">{t(link.title)}</p>}
                  </Fragment>
                ))}
              </ul>
            ))}
          </div>
          <div className="jsp__address-section">
            <div
              className="jsp__address-section__address"
              dangerouslySetInnerHTML={{ __html: salesRep.fullAddress }}
            ></div>

            {salesRep.phone && (
              <div className="jsp__address-section__phone">
                <span>{t("footer.sales.rep.phone")}&nbsp;</span>
                <span>{salesRep.phone}</span>
              </div>
            )}

            {salesRep.emails.map((email) => (
              <div key={email} className="jsp__address-section__email">
                <span>{t("footer.sales.rep.email")}&nbsp;</span>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

type Data = {
  navigation: NavigationNodeDTO[];
  salesRep: {
    /**
     * Contains html
     */
    fullAddress: string;
    phone: string;
    emails: string[];
  };
};

export const createPageFooter = ({ data }: { data: string }) => {
  const footerData = JSON.parse(data) as Data;

  return <PageFooter {...footerData} />;
};
